import { useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen } from '../experiments/useExperiment';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { useCurrentStep } from './useCurrentStep';
import { Tracker } from '../store/tracking/action-creators';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { useSelector, useDispatch } from 'react-redux';
import { getGuessedDataBreeze } from '../store/guessed-prefill/selectors';
export const useACQ167Experiment = () => {
  const {
    currentStep
  } = useCurrentStep();
  const dispatch = useDispatch();
  const companyName = useSelector(state => getSignupDataValue(state, Data.CompanyName));
  const guessedCompanyName = useSelector(getGuessedDataBreeze(Data.CompanyName));
  const {
    isAssignedToSpecificVariant
  } = useExperiment(ExperimentKeys.ACQ0167, TrackWhen.never);
  const isAssignedToACQ167Variant_B = isAssignedToSpecificVariant(ExperimentParameterGroup.Variant_B);
  const trackCompanyNameChanged = () => {
    if (isAssignedToACQ167Variant_B) {
      if (companyName !== guessedCompanyName) {
        dispatch(Tracker.signupInteraction('breeze-company-name-prefilled-changed'));
      }
    }
  };
  const acq167HelpText = isAssignedToACQ167Variant_B ? `views.${currentStep}.acq0167HelperText` : `views.${currentStep}.help`;
  return {
    isAssignedToACQ167Variant_B,
    acq167HelpText,
    trackCompanyNameChanged
  };
};